import PropTypes from 'prop-types';

export default function PageHeader({ title, subtitle, maxWidth = 'max-w-6xl' }) {
  return (
    <div className="bg-slate-900 pt-24 pb-12 sm:pt-32 sm:pb-20 relative overflow-hidden border-b border-slate-800">
      
      <div className="absolute inset-0 opacity-10 pointer-events-none" 
           style={{ backgroundImage: 'radial-gradient(#3b82f6 1px, transparent 1px)', backgroundSize: '40px 40px' }}>
      </div>
      <div className="absolute top-0 right-0 -mr-20 -mt-20 w-96 h-96 bg-blue-500 opacity-10 rounded-full blur-3xl pointer-events-none"></div>

      <div className={`mx-auto ${maxWidth} px-6 lg:px-8 relative z-10`}>
        <div className="max-w-3xl lg:mx-0">
          
          <div className="w-12 h-1 bg-cyan-500 rounded-full mb-6"></div>

          <h1 className="text-3xl font-extrabold tracking-tight text-white sm:text-5xl drop-shadow-sm leading-tight">
            {title}
          </h1>
          
          {subtitle && (
            <p className="mt-4 sm:mt-6 text-lg sm:text-xl leading-relaxed text-blue-100/80 font-light border-l-2 border-cyan-500/30 pl-6">
              {subtitle}
            </p>
          )}
        </div>
      </div>
    </div>
  );
}

PageHeader.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  maxWidth: PropTypes.string,
};
